module.exports = __webpack_public_path__ + "img/total_vehicles.994f565d.svg";